<template>
  <div class="home-layout">
    <main class="main">
      <div :class="[$style.columns]">
        <div :class="['column', $style.landingTextCol]">
          <div :class="[$style.landingText]">
            <img
              src="@/assets/images/logo_paces@2x.png"
              :class="$style.jbiLogo"
            />
            <p :class="$style.SubscriptionHeaderLabel">
              Your subscription has expired.
            </p>
            <p :class="$style.SubscriptionSubHeaderLabel">
              Please extend your subscription to continue using PACES.
            </p>
            <b-button
              rounded
              @click="redirectToJaas"
              :class="[$style.redirectBtn]"
              type="is-primary"
            >
              Extend Subscription
            </b-button>
            <p :class="$style.logoutLink">
              <a @click="signOut">Log Out</a>
            </p>
            <p :class="$style.redirectToJaasLink">
              <a :href="`${JAAS_DASHBOARD_URL}`">Go to jbi.global</a>
            </p>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import HomeHeader from '@/views/Home/components/HomeHeader.vue';
import HomeLayout from '../../layouts/HomeLayout.vue';
import { useAction } from '@/utils/store.util';

@Component({ components: { HomeHeader, HomeLayout } })
export default class ExtendSubscription extends Vue {
  public redirectToJaas() {
    window.location.href =
      process.env.VUE_APP_JAAS_DASHBOARD_URL + `/application/paces/products`;
  }
  get signOut() {
    return useAction.call(this, 'auth/signOut');
  }
}
</script>

<style lang="scss" module>
.container {
  height: 100%;
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
}

.default-layout {
  display: none !important;
}
.landingWrapper {
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.columns {
  height: 100%;
  display: flex;
  flex: 1 1 0;
}

.landingTextCol {
  display: flex;
  justify-content: flex-start;
  margin-left: 40%;
  margin-top: 100px;
  text-align: center;
}

.landingText {
  padding-bottom: 130px;
}

.landingPagePic {
  height: 100%;
  background-image: url('~@/assets/images/landing/paces_home_banner.png');
  background-repeat: no-repeat;
  background-size: cover;
}

.jbiLogo {
  padding-bottom: 60px;
}

.SubscriptionHeaderLabel {
  color: #444f51;
  font-size: 18px;
  font-weight: bold;
  line-height: 23px;
  max-width: 392px;
}

.SubscriptionSubHeaderLabel {
  padding-top: 10px;
  color: #444f51;
  font-size: 16px;
  line-height: 19px;
}
.redirectBtn {
  margin-top: 50px;
  color: #ffffff;
  font-size: 18px;
  padding: 12px 20px;
}
.redirectToJaasLink {
  color: #00205b;
  font-size: 14px;
  line-height: 17px;
  padding-top: 40px;
  font-weight: bold;
}
.logoutLink {
  color: #00205b;
  font-size: 14px;
  line-height: 17px;
  padding-top: 24px;
  font-weight: bold;
}
</style>
